import { render, staticRenderFns } from "./RefinementForm.vue?vue&type=template&id=74a06ed5&"
import script from "./RefinementForm.vue?vue&type=script&lang=js&"
export * from "./RefinementForm.vue?vue&type=script&lang=js&"
import style0 from "./RefinementForm.vue?vue&type=style&index=0&id=74a06ed5&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports